// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseAsrFilterLimitCheckResponse } from '../../types';

/**
 * checkAsrFilterLimit
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [GET] /asr-filter-config/samplingLimit
 */
export function getAsrFilterConfigSamplingLimit(): Promise<BaseResponseAsrFilterLimitCheckResponse>;
export function getAsrFilterConfigSamplingLimit(
    options: ApiOptions<never, never>
): Promise<BaseResponseAsrFilterLimitCheckResponse>;
export function getAsrFilterConfigSamplingLimit(
    options?: ApiOptions<never, never>
): Promise<BaseResponseAsrFilterLimitCheckResponse> {
    return request<never, never, never>('/asr-filter-config/samplingLimit', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAsrFilterConfigSamplingLimit',
    });
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/samplingLimit',
        method: 'get',
    },
];
